import { Box, IconButton, TextField } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useState } from 'react';

export const CopilotInput = ({ disabled, onSubmit, placeholder = 'Ask G.AI' }) => {
  const [value, setValue] = useState('');

  const submitHandler = () => {
    const question = value.trim();
    if (!question) return;
    onSubmit(question);
    setValue('');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        gap: 1,
        p: 1,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 4,
        bgcolor: 'common.white',
        boxShadow: '0 8px 24px rgba(17, 30, 33, 0.08)',
      }}
    >
      <TextField
        fullWidth
        multiline
        maxRows={4}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        variant="standard"
        InputProps={{
          disableUnderline: true,
          sx: {
            px: 1.5,
            py: 1,
            fontSize: '1rem',
          },
        }}
        onChange={(event) => setValue(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            submitHandler();
          }
        }}
      />
      <IconButton
        aria-label="Ask G.AI"
        disabled={disabled || !value.trim()}
        onClick={submitHandler}
        sx={{
          bgcolor: value.trim() && !disabled ? 'primary.main' : 'lightGrey.main',
          color: value.trim() && !disabled ? 'common.white' : 'text.secondary',
          '&:hover': {
            bgcolor: value.trim() && !disabled ? 'primary.dark' : 'lightGrey.dark',
          },
        }}
      >
        <ArrowUpwardIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};
